import {
  AppTopNavi,
  Button,
  Dialog,
  Icon,
  Menu,
  MenuItem,
  Tooltip,
  WithTooltip,
} from "@abb/abb-common-ux-react";
import React from "react";
import { v4 as uuidv4 } from "uuid";
import { Translation } from "react-i18next";
import instrumentActions from "../../flux/actions/InstrumentActions";
import { IDeviceViewData } from "../../models/device/DeviceViewData";
import IInstrumentSampleDetails, {
  defaultInstrumentSampleDetailsData,
  InstrumentSampleDetails,
} from "../../models/instrument/InstrumentSampleData";
import { IInstrumentViewData } from "../../models/instrument/InstrumentViewData";
import {
  defaultSampleDetails,
  ISampleDetails,
} from "../../models/instrument/SampleDetails";
import {
  defaultInstrumentDetails,
  IMeasurementProperties,
  InstrumentDetails,
  IReadings,
} from "../../models/measurement/InstrumentDetails";
import { Status } from "../../models/sample/Status";
import {
  defaultMeasurementSettingData,
  MeasurementSetting,
} from "../../models/settings/MeasurementSettings";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import {
  EXCEPTION_HUB,
  HANDLE_EXCEPTION,
  HUB_SETCONTEXT,
  INSTRUMENT_HUB,
  MEASUREMENT_AL_HUB,
  MEASUREMENT_HUB,
  MEASUREMENT_HUB_RECEIVE_AL_STATUS,
  MEASUREMENT_HUB_RECEIVE_INSTRUMENT_STATUS,
  MEASUREMENT_HUB_RECEIVE_MEASUREMENT,
  MEASUREMENT_HUB_RECEIVE_MEASUREMENT_COUNT,
  RE_TRY_ATTEMPTS,
  SAMPLE_HUB_RECEIVE_SAMPLE_STATUS,
  STATUS_HUB,
} from "../../utilities/HubConstants";
import * as CONSTANTS from "../../utilities/Constants";

import History from "../../utilities/History";
import Dashboard from "./Dashboard";
import measurementActions from "../../flux/actions/MeasurementActions";
import triggerNotifications from "../../utilities/TriggerNotifications";
import measurementSettingStore from "../../flux/stores/settings/MeasurementSettingStore";
import thresholdSettingStore from "../../flux/stores/settings/ThresholdSettingStore";
import SampleInstrumentDetailsStore from "../../flux/stores/measurement/SampleInstrumentDetailsStore";
import InstrumentSampleDetailsStore from "../../flux/stores/instrument/InstrumentSampleStore";

import * as signalR from "@microsoft/signalr";
import settingsActions from "../../flux/actions/SettingsAction";
import APIErrorCode from "../../utilities/ErrorCode.json";
import Summary from "../sharedNew/Summary";
import { IActionHeaderEditData } from "../../models/shared/ActionHeaderData";
import actionHeaderEditStore from "../../flux/stores/shared/ActionHeaderEditStore";
import sampleActions from "../../flux/actions/SampleActions";
import InstrumentProperty from "./InstrumentProperty";
import InstrumentPropertyDetails from "./InstrumentPropertyDetails";
import _ from "lodash";
import authUtility from "../../utilities/AuthUtility";
import i18next from "i18next";

interface IProps {
  deviceData: IDeviceViewData;
  instrumentId: string;
  instrumentData: IInstrumentViewData;
  sidebarCollapsed: boolean;
  childRef?: any;
}

interface IState {
  list: any;
  instrumentId: string;
  selectedSampleDetail: any;
  selectPage: number;
  isSummaryToggle: boolean;
  isPropertyToggle: boolean;
  measurementDetails: any;
  selectSample: number;
  selectedInstrumentDetail: ISampleDetails;
  showInstrumentStopDialog: boolean;
  showInstrumentRemeasureDialog: boolean;
  activeDirectionIndx: number;
  settings: MeasurementSetting;
  thresholdSettings: IThresholdSettings[];
  editData: any;
  isEditShow: boolean;
  deleteModalVisible: boolean;
  isDashboardDetails: number;
  deleteTitle: string;
  deleteId: string;
  deleteRequesId: string;
  deleteMessage: string;
  moduleName: string;
  selectedPositionFromMeasuring: any;
  selectedPosition: any;
}
export default class IntrumentOverview extends React.Component<IProps, IState> {
  private _messages: [];
  private _message: any;
  private _onEditCall: boolean = true;
  private _mount: boolean = true;
  private _measurementDetails: IInstrumentSampleDetails;
  private _measurementConnection: signalR.HubConnection;
  private _instrumentConnection: signalR.HubConnection;
  private _sampleConnection: signalR.HubConnection;
  private _selectedPosition: any = 0;
  private _exceptionConnection: signalR.HubConnection;
  private _autolineConnection: signalR.HubConnection;
  private _currentMeasuringProperty: string;
  private _currentMeasuringPosition: number;
  private _sampleInstrumentDetails: any;
  private _currentInstrumentId: any;
  private _instrumentSection: any;
  private _settingsData: any;
  private _thresholdSettings: IThresholdSettings[];
  constructor(props: any) {
    super(props);
    this._mount = true;
    this._instrumentSection = React.createRef();

    this.state = {
      instrumentId: this.props.instrumentId,
      list: [],
      selectedSampleDetail: defaultInstrumentDetails,
      selectPage: 2,
      isSummaryToggle: true,
      isPropertyToggle: true,
      measurementDetails: defaultInstrumentSampleDetailsData,
      selectSample: 0,
      selectedInstrumentDetail: defaultSampleDetails,
      showInstrumentStopDialog: false,
      showInstrumentRemeasureDialog: false,
      activeDirectionIndx: 0,
      settings: defaultMeasurementSettingData,
      thresholdSettings: [],
      isEditShow: false,
      editData: {},
      deleteModalVisible: false,
      isDashboardDetails: 1,
      deleteTitle: "",
      deleteId: "",
      deleteRequesId: "",
      deleteMessage: "",
      moduleName: "",
      selectedPositionFromMeasuring: null,
      selectedPosition: null,
    };
  }

  componentWillUnmount() {
    this._mount = false;
    this.stopHubConnections();
  }

  private measurementHubStart = () => {
    if (this._measurementConnection?.state === "Disconnected") {
      this._measurementConnection
        ?.start()
        .then(() => {
          this._measurementConnection
            .send(HUB_SETCONTEXT, this.state.selectedSampleDetail?.id)
            .then()
            .catch((err) => console.log(err));
        })
        .catch((error) => {
          this._measurementConnection.stop().then(() => {
            this.measurementHubStart();
          });
        });
    }
  };

  private stopHubConnections = () => {
    this._measurementConnection?.stop().then(() => {
      console.log("Measurement Hub Stopped");
    });
    this._instrumentConnection?.stop().then(() => {
      console.log("Instrument Hub Stopped");
    });
    this._sampleConnection?.stop().then(() => {
      console.log("SAMPLE Hub Stopped");
    });
    this._exceptionConnection?.stop().then(() => {
      console.log("EXECPTION Hub Stopped");
    });
    this._autolineConnection
      ?.stop()
      .then(() => console.log("STOPPED AUTOLINE HUB"));
  };

  private sampleHubStart = () => {
    if (
      this._sampleConnection &&
      this._sampleConnection !== undefined &&
      this._sampleConnection?.state === "Disconnected"
    ) {
      this._sampleConnection
        ?.start()
        .then(() => {
          this._sampleConnection
            .send(HUB_SETCONTEXT, this.state.selectedSampleDetail?.id)
            .then()
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((err) => {
          console.log("ERRORHUB SAMPLE ", err);
          this._sampleConnection.stop().then(() => {
            this.sampleHubStart();
          });
        });
    }
  };

  private exceptionHubStart = () => {
    this._exceptionConnection
      ?.start()
      .then()
      .catch((err) => {
        this._exceptionConnection.stop().then(() => {
          this.exceptionHubStart();
        });
      });
  };

  private autolineHubStart = () => {
    if (
      this._autolineConnection &&
      this._autolineConnection !== undefined &&
      this._autolineConnection?.state === "Disconnected"
    ) {
      this._autolineConnection
        ?.start()
        .then()
        .catch((error) => {
          console.log("ERROR AUTOLINE HUB  :>> ", error);
          this._autolineConnection.stop().then(() => {
            this.autolineHubStart();
          });
        });
    }
  };

  private instrumentHubStart = () => {
    this._instrumentConnection
      ?.start()
      .then(() => {
        this._instrumentConnection
          .send(HUB_SETCONTEXT, [this.state.measurementDetails.id])
          .then()
          .catch((error) => console.log(error));
      })
      .catch((err) => {
        this._instrumentConnection.stop().then(() => {
          this.instrumentHubStart();
        });
      });
  };

  public onSelectTab = (index: number, details: number = 1) => {
    const selSample = this.state.measurementDetails.sampleDetails[index];
    this.setState(
      {
        selectSample: index,
        selectedSampleDetail: selSample,
        isDashboardDetails: details,
      },
      () => {
        this._selectedPosition = 0;

        if (this._measurementConnection?.state === "Disconnected") {
          this.stopHubConnections();
          this.measurementHubStart();
          this.sampleHubStart();
          this.exceptionHubStart();
          this.autolineHubStart();
          this.instrumentHubStart();
        }
      }
    );
  };

  private getInitialData(isConnection: boolean) {
    instrumentActions
      .getSampleInstrumentDetails(this.props.instrumentId)
      .then(() => {
        if (this._mount) {
          let sampDetails: any[] = [];
          this._measurementDetails?.sampleDetails.forEach((selSample: any) => {
            const measurementProperties: IMeasurementProperties[] = [];
            selSample?.properties?.forEach((prop: any) =>
              measurementProperties.push({
                id: prop.id,
                name: prop.name,
                unit: prop.unit,
                directionId: prop.directionId,
                decimals: prop.decimals,
              })
            );
            sampDetails.push(
              new InstrumentDetails(
                selSample.id,
                selSample.name,
                selSample.count,
                selSample.directionCounts,
                measurementProperties,
                selSample.readings,
                selSample.instrumentSampleStatus,
                selSample.positionCount,
                selSample.statistics,
                selSample.propertyMeans,
                selSample.positionMeans,
                selSample.isAutoLine,
                selSample.measurementId,
                this._measurementDetails.instrumentStatus,
                selSample.testPlan,
                selSample.instrumentSampleStatus,
              )
            );
          });
          let measurementDetails: IInstrumentSampleDetails =
            new InstrumentSampleDetails(
              this._measurementDetails.id,
              this._measurementDetails.name,
              this._measurementDetails.description,
              this._measurementDetails.isEnabled,
              this._measurementDetails.measurementId,
              this._measurementDetails.orderId,
              this._measurementDetails.sampleDate,
              this._measurementDetails.setId,
              sampDetails,
              this._measurementDetails.instrumentStatus
            );
          this.setState(
            {
              measurementDetails: measurementDetails,
            },
            () => {
              const measurementDetails = { ...this.state.measurementDetails };
              const measuringSamp =
                this.state.measurementDetails.sampleDetails.find(
                  (x: any) => x.status.name === Status.MEASURING
                );
              const measuringSampIndex =
                this.state.measurementDetails.sampleDetails.findIndex(
                  (x: any) => x.status.name === Status.MEASURING
              );
              const stoppedSamp = this.state.measurementDetails.sampleDetails.find(
                (x: any) => x.id === this.state.selectedSampleDetail?.id
              );
              const stoppedSampIndex =
              this.state.measurementDetails.sampleDetails.findIndex(
                  (x: any) => x.id === this.state.selectedSampleDetail?.id
              );
              const selSample = measuringSamp
                ? measuringSamp
                : stoppedSamp
              const measurementProperties: IMeasurementProperties[] = [];
              let selectedSampleDetail:any;
              if (selSample) {
                selSample?.properties?.forEach((prop: any) =>
                  measurementProperties.push({
                    id: prop.id,
                    name: prop.name,
                    unit: prop.unit,
                    directionId: prop.directionId,
                    decimals: prop.decimals,
                  })
                );
                selectedSampleDetail = new InstrumentDetails(
                  selSample.id,
                  selSample.name,
                  selSample.count,
                  selSample.directionCounts,
                  measurementProperties,
                  selSample.readings,
                  selSample.currentSampleStatus,
                  selSample.positionCount,
                  selSample.statistics,
                  selSample.propertyMeans,
                  selSample.positionMeans,
                  false,
                  selSample.measurementId,
                  measurementDetails.instrumentStatus,
                  selSample.testPlan
                );
              }
              const selectSample = measuringSamp ? measuringSampIndex : stoppedSampIndex;

              let selectedPosition = this.state.selectedPosition;
              if(selectedPosition && Object.keys(selectedPosition).length && selectedSampleDetail && selectedSampleDetail.nextMeasuringPositionDireaction && this.state.isDashboardDetails > 1){
                selectedPosition =
                selectedSampleDetail.countData.find(
                  (elements: any) =>
                    elements.position === selectedSampleDetail.nextMeasuringPositionDireaction?.position??0
                );
              }
                    

              this.setState(
                {
                  selectSample,
                  selectedSampleDetail: selectedSampleDetail,
                  selectedPosition,
                },
                () => {
                  this.stopHubConnections();
                  if (measuringSamp) {
                    this.onSelectTab(
                      selectSample,
                      this.state.isDashboardDetails
                    );
                    setTimeout(() => {
                      // START MEASUREMENT HUB BY DEFAULT
                      this.measurementHubStart();
                      this.sampleHubStart();
                      this.exceptionHubStart();
                      this.autolineHubStart();
                      // start INSTRUMENT CONNECTION HUB
                      if (isConnection) {
                        this.instrumentHubStart();
                      }
                    }, 100);
                  }
                }
              );
            }
          );
        }
      });
  }

  public getInitialDataTest = (isConnection: boolean) => {
    instrumentActions
      .getSampleInstrumentDetails(this.props.instrumentId)
      .then(() => {
        if (this._mount) {
          let sampDetails: any[] = [];
          this._measurementDetails?.sampleDetails.forEach((selSample: any) => {
            const measurementProperties: IMeasurementProperties[] = [];
            selSample?.properties?.forEach((prop: any) =>
              measurementProperties.push({
                id: prop.id,
                name: prop.name,
                unit: prop.unit,
                directionId: prop.directionId,
                decimals: prop.decimals,
              })
            );
            sampDetails.push(
              new InstrumentDetails(
                selSample.id,
                selSample.name,
                selSample.count,
                selSample.directionCounts,
                measurementProperties,
                selSample.readings,
                selSample.instrumentSampleStatus,
                selSample.positionCount,
                selSample.statistics,
                selSample.propertyMeans,
                selSample.positionMeans,
                selSample.isAutoLine,
                selSample.measurementId,
                this._measurementDetails.instrumentStatus,
                selSample.testPlan,
                selSample.instrumentSampleStatus,
              )
            );
          });
          let measurementDetails: IInstrumentSampleDetails =
            new InstrumentSampleDetails(
              this._measurementDetails.id,
              this._measurementDetails.name,
              this._measurementDetails.description,
              this._measurementDetails.isEnabled,
              this._measurementDetails.measurementId,
              this._measurementDetails.orderId,
              this._measurementDetails.sampleDate,
              this._measurementDetails.setId,
              sampDetails,
              this._measurementDetails.instrumentStatus
            );
          this.setState(
            {
              measurementDetails: measurementDetails,
            },
            () => {
              const measurementDetails = { ...this.state.measurementDetails };
              const measuringSamp =
                this.state.measurementDetails.sampleDetails.find(
                  (x: any) => x.status.name === Status.MEASURING
                );
              const measuringSampIndex =
                this.state.measurementDetails.sampleDetails.findIndex(
                  (x: any) => x.status.name === Status.MEASURING
              );
              const stoppedSamp = this.state.measurementDetails.sampleDetails.find(
                (x: any) => x.id === this.state.selectedSampleDetail?.id
              );
              const stoppedSampIndex =
              this.state.measurementDetails.sampleDetails.findIndex(
                  (x: any) => x.id === this.state.selectedSampleDetail?.id
              );
              const selSample = measuringSamp
                ? measuringSamp
                : stoppedSamp
              const measurementProperties: IMeasurementProperties[] = [];
              let selectedSampleDetail:any;
              if (selSample) {
                selSample?.properties?.forEach((prop: any) =>
                  measurementProperties.push({
                    id: prop.id,
                    name: prop.name,
                    unit: prop.unit,
                    directionId: prop.directionId,
                    decimals: prop.decimals,
                  })
                );
                selectedSampleDetail = new InstrumentDetails(
                  selSample.id,
                  selSample.name,
                  selSample.count,
                  selSample.directionCounts,
                  measurementProperties,
                  selSample.readings,
                  selSample.currentSampleStatus,
                  selSample.positionCount,
                  selSample.statistics,
                  selSample.propertyMeans,
                  selSample.positionMeans,
                  false,
                  selSample.measurementId,
                  measurementDetails.instrumentStatus,
                  selSample.testPlan
                );
              }
              const selectSample = measuringSamp ? measuringSampIndex : stoppedSampIndex;

              let selectedPosition = this.state.selectedPosition;
              if(selectedPosition && Object.keys(selectedPosition).length && selectedSampleDetail && selectedSampleDetail.nextMeasuringPositionDireaction && this.state.isDashboardDetails > 1){
                selectedPosition =
                selectedSampleDetail.countData.find(
                  (elements: any) =>
                    elements.position === selectedSampleDetail.nextMeasuringPositionDireaction?.position??0
                );
              }
                    

              this.setState(
                {
                  selectSample,
                  selectedSampleDetail: selectedSampleDetail,
                },
                () => {
                  this.stopHubConnections();
                  if (measuringSamp) {
                    this.onSelectTab(
                      selectSample,
                      this.state.isDashboardDetails
                    );
                    setTimeout(() => {
                      // START MEASUREMENT HUB BY DEFAULT
                      this.measurementHubStart();
                      this.sampleHubStart();
                      this.exceptionHubStart();
                      this.autolineHubStart();
                      // start INSTRUMENT CONNECTION HUB
                      if (isConnection) {
                        this.instrumentHubStart();
                      }
                    }, 100);
                  }
                }
              );
            }
          );
        }
      });
  }

  public onRefresh = () => {
    this.getInitialData(true);
  };

  private onEditCall = () => {
    if (this._onEditCall) {
      this._onEditCall = false;
      setTimeout(() => {
        this.setState(
          {
            isEditShow: !this.state.isEditShow,
          },
          () => {
            this._onEditCall = true;
          }
        );
      }, 300);
    }
  };
  private onEditClick = () => {
    History.push(CONSTANTS.INSTRUMENT_CREATE_URL, this.state.editData);
  };
  private openDeleteDialog = () => {
    this.setState({ deleteModalVisible: true });
  };

  private onDeleteClick = () => {
    const ids: any = [];      
    ids.push(this.state.deleteId);
    instrumentActions
      .deleteMultiple(ids, this.state.deleteRequesId)
      .then(() => {
        triggerNotifications.success(this._messages);
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data);
      });
    this.setState({ deleteModalVisible: false });
  };
  private getDefaultInstrumentdata = (
    sampleId: string,
    isConnection: boolean = false
  ) => {
    var selectedSampleDetail = this.state.measurementDetails.sampleDetails.find(
      (x: any) => x.id === sampleId
    );
    this.setState(
      {
        selectedSampleDetail,
      },
      () => {
        this.getInitialData(isConnection);
      }
    );
  };

  private startSampleMeasurement = (sampleId: string) => {
    measurementActions.startMeasurement(sampleId, uuidv4()).then(() => {
      this.getDefaultInstrumentdata(sampleId, true);
    });
  };
  private startInstrumentMeasurement = (e: any, sampleId: string) => {
    var selectedSampleDetail = this.state.measurementDetails.sampleDetails.find(
      (x: any) => x.id === sampleId
    );
    this.setState(
      {
        selectedSampleDetail,
      },
      () => {
        if (
          this.state.selectedSampleDetail?.measurementId ===
          CONSTANTS.DefaultGuid
        ) {
          // start sample measurment.
          this.startSampleMeasurement(this.state.selectedSampleDetail?.id);
        } else {
          measurementActions
            .startInstrumentMeasurement(
              this.state.selectedSampleDetail?.id,
              this.state.selectedSampleDetail.measurementId,
              this.state.measurementDetails.id,
              uuidv4()
            )
            .then(() => {
              this.getDefaultInstrumentdata(
                this.state.selectedSampleDetail?.id,
                true
              );
            })
            .catch((error) => {
              triggerNotifications.errors(error.message, error.data).then();
            });
        }
      }
    );
    e.stopPropagation();
  };

  private stopInstrumentMeasurement = (e: any, instrumentId: string) => {
    this._currentInstrumentId = instrumentId;
    this.setState({
      showInstrumentStopDialog: true,
    });
    e.stopPropagation();
  };

  private resumeInstrumentMeasurement = (e: any, instrumentId: string) => {
    measurementActions
      .resumeInstrumentMeasurement(
        this.state.selectedSampleDetail?.id,
        this.state.selectedSampleDetail.measurementId,
        instrumentId,
        uuidv4()
      )
      .then(() => {
        this.getDefaultInstrumentdata(
          this.state.selectedSampleDetail?.id,
          true
        );
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
    e.stopPropagation();
  };

  private remeasureInstrumentMeasurement = (e: any, instrumentId: string) => {
    this._currentInstrumentId = instrumentId;
    this.setState({
      showInstrumentRemeasureDialog: true,
    });
    e.stopPropagation();
  };

  private showDashboardDetails = (screen:number=1) => {
    this.setState({
      isDashboardDetails: screen,
    });
  };
  private getGeneralSettings = () => {
    settingsActions
      .getGeneral()
      .then(() => {
        this.setState({
          settings: this._settingsData,
        });
      })
      .catch((e: any) => {
        triggerNotifications.error(e);
      });
  };
  private getThresholdValues = () => {
    settingsActions
      .getThresholdReport()
      .then(() => {
        this.setState({
          thresholdSettings: this._thresholdSettings,
        });
      })
      .catch((e) => {
        triggerNotifications.error(e);
      });
  };

  private stopAfterConfirm = () => {
    let sampleDetails = this.state.measurementDetails.sampleDetails.find((x:any)=>x.id === this._currentInstrumentId);
    measurementActions
      .stopInstrumentMeasurement(
        this._currentInstrumentId,
        sampleDetails.measurementId,
        this.state.measurementDetails.id,
        uuidv4()
      )
      .then(() =>
        this.setState(
          {
            showInstrumentStopDialog: false,
          },
          () =>
            this.getDefaultInstrumentdata(
              this.state.selectedSampleDetail?.id,
              true
            )
        )
      )
      .catch((error) => {
        this.setState(
          {
            showInstrumentStopDialog: false,
          },
          () => triggerNotifications.errors(error.message, error.data).then()
        );
      });
  };
  private remeasureAfterConfirmation = () => {
    let sampleDetails = this.state.measurementDetails.sampleDetails.find((x:any)=>x.id === this._currentInstrumentId);
    measurementActions
      .remeasureInstrumentMeasurement(
        this._currentInstrumentId,
        sampleDetails.measurementId,
        this.state.measurementDetails.id,
        uuidv4()
      )
      .then(() => {
        this.setState(
          {
            showInstrumentRemeasureDialog: false,
            selectedPositionFromMeasuring:
              this.state.selectedPositionFromMeasuring &&
              this.state.selectedPositionFromMeasuring.measurementId ===
                this.state.selectedSampleDetail.measurementId
                ? null
                : this.state.selectedPositionFromMeasuring,
          },
          () =>
            this.getDefaultInstrumentdata(
              this.state.selectedSampleDetail?.id,
              true
            )
        );
      })
      .catch((error) => {
        this.setState(
          {
            showInstrumentRemeasureDialog: false,
          },
          () => triggerNotifications.errors(error.message, error.data).then()
        );
      });
  };
  componentDidMount() {
    this._mount = true;

    Object.defineProperty(WebSocket, "OPEN", {
      value: 1,
    });
    measurementSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._settingsData = state.data;
      }
    });

    thresholdSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._thresholdSettings = state.data;
      }
    });
    SampleInstrumentDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._sampleInstrumentDetails = state.data;
      }
    });
    InstrumentSampleDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        console.log("state :>> ", state);
        this._measurementDetails = state.data;
      }
    });

    if (this._mount) {
      this.getGeneralSettings();
      this.getThresholdValues();

      this.getInitialData(true);

      // SET Measurement Connection HUB
      this._measurementConnection = new signalR.HubConnectionBuilder()
        .withUrl(MEASUREMENT_HUB)
        .withAutomaticReconnect(RE_TRY_ATTEMPTS)
        .build();

      // SET INSTRUMENT CONNECTION HUB
      this._instrumentConnection = new signalR.HubConnectionBuilder()
        .withUrl(INSTRUMENT_HUB)
        .withAutomaticReconnect(RE_TRY_ATTEMPTS)
        .build();

      this._sampleConnection = new signalR.HubConnectionBuilder()
        .withUrl(STATUS_HUB)
        .withAutomaticReconnect(RE_TRY_ATTEMPTS)
        .build();

      this._exceptionConnection = new signalR.HubConnectionBuilder()
        .withUrl(EXCEPTION_HUB)
        .withAutomaticReconnect(RE_TRY_ATTEMPTS)
        .build();

      this._autolineConnection = new signalR.HubConnectionBuilder()
        .withUrl(MEASUREMENT_AL_HUB)
        .withAutomaticReconnect(RE_TRY_ATTEMPTS)
        .build();

      this._exceptionConnection.on(HANDLE_EXCEPTION, (message: string) => {
        if (this._mount) {
          if (message !== undefined) {
            const messages = [];
            const str = message.substring(1, message.length - 1);
            const elm = str.split(":");
            const eCode = APIErrorCode.ErrorCode.find(
              (x) => x["Message code "] === elm[0]
            );
            if (eCode !== undefined) {
              if (elm[1].length > 1) {
                messages.push(eCode.Message);
              } else if (elm[1].length > 2) {
                const messageTwo = eCode.Message.format(elm[1][0], elm[1][1]);
                messages.push(messageTwo);
              } else {
                messages.push(eCode.Message);
              }

              triggerNotifications.errors(messages).then();
            }
          }
        }
      });

      this._sampleConnection.on(
        SAMPLE_HUB_RECEIVE_SAMPLE_STATUS,
        (sampleId: string, statusId: string, statusName: Status) => {
          if (this._mount) {
          }
        }
      );

      this._autolineConnection.on(
        MEASUREMENT_HUB_RECEIVE_AL_STATUS,
        (instrumentId: string, status: boolean) => {
          console.log(
            "AUTOLINE HUB CONNECTION ",
            instrumentId,
            " --- ",
            status
          );
          if (status) {
            const sampleDetails =
              this.state.measurementDetails.sampleDetails.find(
                (x: any) => x.id === this.state.selectedSampleDetail?.id
              );
            this.setState(
              {
                selectedSampleDetail: sampleDetails,
              },
              () => this.getDefaultInstrumentdata(instrumentId, true)
            );
          }
        }
      );

      // On onreconnecting show the notification to user.
      this._measurementConnection.onreconnecting(() => {
        triggerNotifications.error(CONSTANTS.RE_CONNECTING);
      });

      // On Reconnected the Measurement Hub set the new context.
      this._measurementConnection.onreconnected(() => {
        this._measurementConnection
          .send(HUB_SETCONTEXT, this.state.selectedSampleDetail?.id)
          .then()
          .catch((err) => console.log(err));
        triggerNotifications.success([CONSTANTS.RE_CONNECTED]);
      });

      // RECEIVE MEASUREMENT DETAILS DATA FROM MEASUREMENT HUB
      this._measurementConnection.on(
        MEASUREMENT_HUB_RECEIVE_MEASUREMENT,
        (
          sampleId: string,
          measurementId: string,
          instrumentId: string,
          propertyId: string,
          directionId: string,
          position: number,
          currentCount: number,
          value: any,
          valueRange: any,
          statistics: any
        ) => {
          console.log(
            "RECEIVE MEASUREMENT DETAILS DATA FROM MEASUREMENT HUB :>> ",
            sampleId,
            measurementId,
            instrumentId,
            propertyId,
            directionId,
            position,
            currentCount,
            value,
            valueRange,
            statistics
          );
          if (
            this.state.measurementDetails.sampleDetails && this.state.measurementDetails.sampleDetails.length && this.state.measurementDetails.sampleDetails.some((x:any)=> x.measurementId === measurementId)  &&
            this.state.measurementDetails.sampleDetails.some((x:any)=> x.id === sampleId) &&
            this.state.measurementDetails.id === instrumentId

          ) {
            const measurementDetails = { ...this.state.measurementDetails };
            const instrumentDetails = [...measurementDetails.sampleDetails];

            const instrumentDetail = measurementDetails.sampleDetails.find(
              (x: any) => x.id === sampleId
            );
            const instrumentDetailIndex =
              measurementDetails.sampleDetails.findIndex(
                (x: any) => x.id === sampleId
              );
            const posMean = instrumentDetail?.positionMeans.find(
                  (x: any) => x.propertyId === propertyId &&
                  x.position === position &&
                  x.directionId === directionId
                );
            const positionName = (instrumentDetail.directionCounts || []).find(
                (eles: any) => eles.position === position
              );
            if (posMean) {
              posMean.mean = statistics.mean;
              posMean.position = position;
            } else if (
              instrumentDetail.positionMeans &&
              instrumentDetail.positionMeans.length
            ) {
              instrumentDetail.positionMeans.push({
                propertyId,
                position,
                mean: statistics.mean,
                positionName: positionName?.name ?? "",
                directionId,
              });
            } else {
              instrumentDetail.positionMeans = [
                {
                  propertyId,
                  position,
                  mean: statistics.mean,
                  positionName: positionName?.name ?? "",
                  directionId,
                },
              ];
            }
            const valueRangeData = { id: "", name: valueRange };
            instrumentDetail.setAverage(
              propertyId,
              directionId,
              position,
              statistics
            );
            const selectedProp = instrumentDetail?.properties.find(
              (x: any) => x.id === propertyId
            );
            instrumentDetail.setReadings(
              currentCount,
              directionId,
              position,
              propertyId,
              value,
              valueRangeData,
              "",
              selectedProp?.decimals
            );
            let previousDirectionMeans: any = [];
            if (instrumentDetail.readings && instrumentDetail.readings.length) {
              previousDirectionMeans =
                instrumentDetail.readings[0].directionMeans || [];
              let isDirAvail = previousDirectionMeans.findIndex(
                (elems: any) =>
                  elems.directionId === directionId &&
                  elems.propertyId === propertyId
              );
              if (isDirAvail >= 0) {
                let positionMeanVal = (
                  instrumentDetail.positionMeans || []
                ).filter(
                  (el: any) =>
                    el.directionId === directionId && el.propertyId === propertyId
                );
  
                let mean =
                  positionMeanVal && positionMeanVal.length
                    ? positionMeanVal
                        .filter((elments: any) => elments.mean && elments.mean !== "NaN")
                        .reduce((partialSum: any, a: any) => {
                          return partialSum + Number(a.mean);
                        }, 0) /
                        positionMeanVal.filter((x:any) => x.mean !== "NaN" && x.mean !== null).length
                    : 0;
  
                previousDirectionMeans.splice(isDirAvail, 1, {
                  directionId,
                  propertyId,
                  mean,
                });
              } else {
                previousDirectionMeans.push({
                  directionId,
                  propertyId,
                  mean: statistics?.mean ?? 0,
                });
              }
            }
            instrumentDetail.readings.forEach((el: any) => {
              el.directionMeans = previousDirectionMeans;
              if (!el.positionName) {
                const positionNamereading = (
                  instrumentDetail.directionCounts || []
                ).find((eles: any) => eles.position === el.position);
                el.positionName = positionNamereading?.name ?? "";
              }
              if (!el.propertyName) {
                const propertyName = (instrumentDetail.properties || []).find(
                  (x: any) =>
                    x.id === el.propertyId && x.directionId === el.directionId
                );
                el.propertyName = propertyName?.name ?? "";
              }
            });

            this._currentMeasuringProperty = propertyId;
            this._currentMeasuringPosition = position;
            instrumentDetail.setCurrentMeasuringProperty(propertyId, position);
            // setPosition
            instrumentDetails[instrumentDetailIndex] = instrumentDetail;
            const dir = instrumentDetail.allDirections.find((x: any) => {
              return x.id === directionId;
            });

            const selectedPositionFromMeasuring = {
              position: position,
              measurementId: measurementId,
            };
            measurementDetails.sampleDetails[instrumentDetailIndex] = instrumentDetail;
            this.setState({
              measurementDetails: measurementDetails,
              selectedSampleDetail: instrumentDetail,
              selectedPositionFromMeasuring,
            },()=>this.forceUpdate());
          }
        }
      );

      // RECEIVE COUNT DATA FROM MEASUREMENT HUB
      this._measurementConnection.on(
        MEASUREMENT_HUB_RECEIVE_MEASUREMENT_COUNT,
        (
          sampleId: any,
          measurementId: any,
          instrumentId: any,
          position: number,
          directionCount: any,
          positionCount: any,
          count: any
        ) => {
          console.log(
            "RECEIVE COUNT DATA FROM MEASUREMENT HUB :>> ",
            sampleId,
            measurementId,
            instrumentId,
            position,
            directionCount,
            positionCount,
            count
          );
          if (
            this.state.measurementDetails.sampleDetails && this.state.measurementDetails.sampleDetails.length && this.state.measurementDetails.sampleDetails.some((x:any)=> x.measurementId === measurementId)  &&
            this.state.measurementDetails.sampleDetails.some((x:any)=> x.id === sampleId) &&
            this.state.measurementDetails.id === instrumentId
          ) {
            const measurementDetails = { ...this.state.measurementDetails };
            const instrumentDetails = [...measurementDetails.sampleDetails];
            const instrumentDetail = measurementDetails.sampleDetails.find(
              (x: any) => x.id === sampleId
            );
            const instrumentDetailIndex =
              measurementDetails.sampleDetails.findIndex(
                (x: any) => x.id === sampleId
              );
            this._selectedPosition = position;
            let activeDirectionIndex = this.state.activeDirectionIndx;
            instrumentDetail.updateDirectionCount(
              position,
              directionCount.directionId,
              directionCount.completedCounts
            );
            instrumentDetail.setCount(count);

            instrumentDetail.setMeasuredPosition(position);
            instrumentDetail.setCurrentMeasuringProperty(
              this._currentMeasuringProperty,
              this._currentMeasuringPosition
            );
            let updatdPosCont = instrumentDetail.positionCount.findIndex(
              (x: any) => x.position === positionCount.position
            );
            instrumentDetail.positionCount[updatdPosCont].selected = true;
            instrumentDetail.positionCount[updatdPosCont].completedCounts =
              positionCount.completedCounts;
            instrumentDetail.positionCount[updatdPosCont].totalCounts =
              positionCount.totalCounts;
            instrumentDetail.setPositionCount(instrumentDetail.positionCount);
            instrumentDetail.setCount(count);
            instrumentDetail.setDirectionCount(
              position,
              directionCount.directionId,
              directionCount.completedCounts
            );

            instrumentDetail.nextMeasuringPositionDireaction =
            instrumentDetail.getNextMeasuringDetails(
              instrumentDetail.countData,
              instrumentDetail.allDirections,
              instrumentDetail.testPlan,
              instrumentDetail.readings
            );
          instrumentDetails[instrumentDetailIndex] = instrumentDetail;

            const allDirectionsObj: any = {};
            instrumentDetail.allDirections.forEach((alldir: any, i: number) => {
              allDirectionsObj[alldir.name] = alldir;
              if (instrumentDetail.testPlan?.isPDC) {
                if (directionCount.directionId === alldir.id) {
                  if (
                    directionCount.completedCounts ===
                    directionCount.totalCounts
                  ) {
                    activeDirectionIndex = activeDirectionIndex + 1;
                    if (
                      instrumentDetail?.countData[position]?.directions[0]
                        ?.totalCounts ===
                        instrumentDetail?.countData[position]?.directions[0]
                          ?.completedCounts &&
                      positionCount.position !==
                        instrumentDetail?.countData.length - 1
                    ) {
                      ++position;
                      instrumentDetail?.countData.forEach((element: any) => {
                        element.selected = false;
                      });
                      positionCount.position = position;
                      instrumentDetail.countData[position].selected = true;
                      instrumentDetail.setPositionVal = position;
                      instrumentDetail.setMeasuredPosition(position);
                      activeDirectionIndex = 0;
                    }
                  } else {
                    activeDirectionIndex = i;
                  }
                }
              } else {
                if (directionCount.directionId === alldir.id) {
                  if (
                    directionCount.completedCounts ===
                    directionCount.totalCounts
                  ) {
                    activeDirectionIndex = activeDirectionIndex + 1;
                    if (
                      instrumentDetail?.countData[position]?.directions[
                        activeDirectionIndex
                      ]?.maxCount ===
                        instrumentDetail?.countData[position]?.directions[
                          activeDirectionIndex
                        ]?.completedCounts &&
                      positionCount.position !==
                        instrumentDetail?.countData.length - 1
                    ) {
                      ++position;
                      instrumentDetail?.countData.forEach((element: any) => {
                        element.selected = false;
                      });
                      positionCount.position = position;
                      instrumentDetail.countData[position].selected = true;
                      instrumentDetail.setPositionVal = position;
                      instrumentDetail.setMeasuredPosition(position);
                      activeDirectionIndex = i;
                    } else if (
                      positionCount.position ===
                      instrumentDetail?.countData.length - 1
                    ) {
                      position = 0;
                      instrumentDetail?.countData.forEach((element: any) => {
                        element.selected = false;
                      });
                      positionCount.position = position;
                      instrumentDetail.countData[position].selected = true;
                      instrumentDetail.setPositionVal = position;
                      instrumentDetail.setMeasuredPosition(position);
                    }
                  } else {
                    activeDirectionIndex = i;
                  }
                }
              }
            });
            let NextPosition: any = null;
        if (instrumentDetail.nextMeasuringPositionDireaction.directionId) {
          NextPosition = instrumentDetail.countData.find(
            (elements: any) =>
              elements.position ===
              (instrumentDetail.nextMeasuringPositionDireaction.position || position)
          );
        }
            instrumentDetails[instrumentDetailIndex] = instrumentDetail;
            measurementDetails.sampleDetails[instrumentDetailIndex] = instrumentDetail;
         
            this.setState({
              measurementDetails: measurementDetails,
              selectedInstrumentDetail: instrumentDetail,
              activeDirectionIndx: activeDirectionIndex,
              selectedPosition : NextPosition,
              isDashboardDetails: !NextPosition  ? 1 : this.state.isDashboardDetails,
            });
          }
        }
      );

      // INSTRUMENT (MEASURED PROPERTY) STATUS HUB
      this._instrumentConnection.on(
        MEASUREMENT_HUB_RECEIVE_INSTRUMENT_STATUS,
        (instrumentId: string, statusId: string, statusName: string) => {
          console.log(
            "INSTRUMENT (MEASURED PROPERTY) STATUS HUB :>> ",
            instrumentId,
            statusId,
            statusName
          );
          if(statusName === Status.MEASURED){
            this.getInitialData(true);
          } else {
          const measurementDetails = { ...this.state.measurementDetails };
          const instrumentDetails = [...measurementDetails.sampleDetails];
          const instrumentDetail = measurementDetails.sampleDetails.find(
            (x: any) => x.id === this.state.selectedSampleDetail?.id
          );
          const instrumentDetailIndex =
            measurementDetails.sampleDetails.findIndex(
              (x: any) => x.id === this.state.selectedSampleDetail?.id
            );

          instrumentDetail.setStatus({ id: instrumentId, name: statusName });
          instrumentDetails[instrumentDetailIndex] = instrumentDetail;
          let mesDetails: IInstrumentSampleDetails =
            new InstrumentSampleDetails(
              measurementDetails.id,
              measurementDetails.name,
              measurementDetails.description,
              measurementDetails.isEnabled,
              measurementDetails.measurementId,
              measurementDetails.orderId,
              measurementDetails.sampleDate,
              measurementDetails.setId,
              instrumentDetails,
              measurementDetails.instrumentStatus
            );

          this.setState(
            {
              activeDirectionIndx: 0,
              measurementDetails: mesDetails,
              selectedInstrumentDetail: instrumentDetail,
            }
          );
        }
      }
      );

      actionHeaderEditStore.on(
        CONSTANTS.CHANGE_EVENT,
        (state: IActionHeaderEditData) => {
          this.setState({
            editData: state.editData,
            deleteTitle: state.deleteTitle,
            deleteId: state.deleteId,
            deleteRequesId: state.deleteRequestId,
            moduleName: state.moduleName,
            deleteMessage: state.deleteMessage,
          });
        }
      );
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (
      this.props !== prevProps &&
      this.props.instrumentId !== prevProps.instrumentId
    ) {
      this.setState(
        {
          list: this.props.instrumentData.properties,
          isDashboardDetails: 1,
          instrumentId: this.props.instrumentId,
        },
        () => {
          this.getInitialData(true);
        }
      );
    }
  }

  private showInstrumentPropertyDetailsComponent = (position?: any) => {
    this.setState({
      selectedPosition: position,
      isDashboardDetails:3,
    });
  };

  private reMeasureDirectionPositionCount = (
    instumentId: string,
    directionId: string,
    position: number,
    count: number,
    isFromPositions: boolean = false
  ) => {
    if (isFromPositions) {
      sampleActions
        .reMeasureLastMeasurementAll(
          this.state.selectedSampleDetail?.id ?? "",
          this.state?.instrumentId ?? "",
          [directionId],
          this.state.selectedSampleDetail?.measurementId ?? "",
          position,
          [count],
          false,
          () =>
            this.getDefaultInstrumentdata(
              this.state.selectedSampleDetail?.id,
              true
            )
        )
        .then(() => {
          this._message = [i18next.t('Instrument remeasured')];
          triggerNotifications.success(this._message).then();
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    } else {
      sampleActions
        .reMeasureLastMeasurement(
          this.state.selectedSampleDetail?.id ?? "",
          this.state?.instrumentId ?? "",
          directionId,
          this.state.selectedSampleDetail?.measurementId ?? "",
          position,
          count,
          () =>
            this.getDefaultInstrumentdata(
              this.state.selectedSampleDetail?.id,
              true
            )
        )
        .then(() => {
          this._message = [i18next.t('Instrument remeasured')];
          triggerNotifications.success(this._message).then();
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    }
  };

  private reMeasureDirectionPositionCountAll = (
    instumentId: string,
    directionId: string[],
    position: any,
    count: number[]
  ) => {
  
    sampleActions
      .reMeasureLastMeasurementAll(
        this.state.selectedSampleDetail?.id ?? "",
        this.state?.instrumentId ?? "",
        directionId,
        this.state.selectedSampleDetail?.measurementId ?? "",
        position,
        count,
        false,
        () =>
          this.getDefaultInstrumentdata(
            this.state.selectedSampleDetail?.id,
            true
          )
      )
      .then(() => {
        this._message = [i18next.t('Instrument remeasured')];
        triggerNotifications.success(this._message).then();
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private reMeasureDirectionPositionCountSingleAll = (
    instumentId: string,
    directionId: string,
    position: number,
    count: number,
    directionIddummy: string[],
    countdummy: number[]
  ) => {
 
    sampleActions
      .reMeasureLastMeasurementAll(
        this.state.selectedSampleDetail?.id ?? "",
        this.state?.instrumentId ?? "",
        directionIddummy,
        this.state.selectedSampleDetail?.measurementId ?? "",
        position,
        countdummy,
        false,
        () =>
          this.getDefaultInstrumentdata(
            this.state.selectedSampleDetail?.id,
            true
          )
      )
      .then(() => {
        this._message = [i18next.t('Instrument remeasured')];
        triggerNotifications.success(this._message).then();
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private skipCountInPosition = (
    IntrumentId: string,
    Position: number,
    direction: string,
    count: number[]
  ) => {
    sampleActions
      .skipCountinPosition(
        this.state.selectedSampleDetail?.id ?? "",
        this.state.measurementDetails?.id??"",
        this.state.selectedSampleDetail?.measurementId ?? "",
        Position,
        direction,
        count,
        false
      )
      .then(() => {
        this._message = [
          `position ${
            Position + 1
          } ${i18next.t("counts are skipped")}`,
        ];
        triggerNotifications.success(this._message).then();

        const measurementDetails = { ...this.state.measurementDetails };
        const instrumentDetails = [...measurementDetails.sampleDetails];

        const instrumentDetail = measurementDetails.sampleDetails.find(
          (x: any) => x.id === IntrumentId
        );

        const instrumentDetailIndex =
          measurementDetails.sampleDetails.findIndex(
            (x: any) => x.id === IntrumentId
          );
        instrumentDetail.countData = instrumentDetail.countData.map(
          (elements: any) => {
            if (elements.position === Position) {
              elements.directions = elements.directions.map((el: any) => {
                if (
                  IntrumentId &&
                  IntrumentId.length &&
                  (el.id === direction || el.name === "All")
                ) {
                  let  skippedDetails = el.skippedDetails || [];
                  if(el.name !== "All")
                  count.forEach((x:number)=> skippedDetails.push(x))
                  return {
                    ...el,
                    skipped: el.skipped
                      ? Number(el.skipped) + Number(count.length)
                      : count.length,
                    completedCounts: el.completedCounts
                    ? Number(el.completedCounts) + Number(count.length)
                    : count.length,
                    skippedDetails
                  };
                } else {
                  return el;
                }
              });
              return elements;
            } else {
              return elements;
            }
          }
        );
        instrumentDetail.nextMeasuringPositionDireaction =
          instrumentDetail.getNextMeasuringDetails(
            instrumentDetail.countData,
            instrumentDetail.allDirections,
            this.state.selectedSampleDetail?.testPlan,
            instrumentDetail.readings,
          );
          let completedCounts: number = 0;
        instrumentDetail.countData.forEach((elem: any) => {
          completedCounts += elem.directions[0]?.completedCounts ?? 0;
        });

        instrumentDetail.setCount({
          completedCounts,
          totalCounts: instrumentDetail.count.totalCounts,
        });
        let NextPosition: any = null;
        if (instrumentDetail.nextMeasuringPositionDireaction.directionId) {
          NextPosition = instrumentDetail.countData.find(
            (elements: any) =>
              elements.position ===
              instrumentDetail.nextMeasuringPositionDireaction.position
          );
        }
        instrumentDetails[instrumentDetailIndex] = instrumentDetail;
        this.setState({
          measurementDetails: {
            ...this.state.measurementDetails,
            instrumentDetails,
          },
          selectedPosition: NextPosition,
          isDashboardDetails: (!NextPosition && this.state.isDashboardDetails=== 3) ? 2 : this.state.isDashboardDetails,
        });
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private endPositionFunc = (IntrumentId: string, Position: number) => {
    const measurementDetails = { ...this.state.measurementDetails };
    const instrumentDetails = [...measurementDetails.sampleDetails];

    const instrumentDetail = measurementDetails.sampleDetails.find(
      (x: any) => x.id === IntrumentId
    );
    const instrumentDetailIndex =
    measurementDetails.sampleDetails.findIndex(
      (x: any) => x.id === IntrumentId
    );
    let directionId = [];
    if (
      this.state.selectedSampleDetail?.testPlan &&
      this.state.selectedSampleDetail.testPlan?.isPDC
    ) {
      directionId = instrumentDetail.allDirections.map((el: any) => {
        return el.id;
      });
    } else {
      directionId = [
        this.state.selectedSampleDetail.nextMeasuringPositionDireaction
          ?.directionId,
      ];
    }

    sampleActions
      .endPosition(
        this.state.selectedSampleDetail?.id ?? "",
        this.state.measurementDetails?.id??"",
        this.state.selectedSampleDetail?.measurementId ?? "",
        Position,
        directionId
      )
      .then(() => {
        this._message = [
          `position ${
            Position + 1
          } ended`,
        ];
        triggerNotifications.success(this._message).then();

        
        instrumentDetail.countData = instrumentDetail.countData.map(
          (elements: any) => {
            if (elements.position === Position) {
              if (
                this.state.selectedSampleDetail?.testPlan &&
                this.state.selectedSampleDetail.testPlan?.isPDC
              ) {
                elements.directions = elements.directions.map((el: any) => {
                  const skipped =
                    (el?.skipped ?? 0) + (el.totalCounts - el.completedCounts);

                    let findCount = (instrumentDetail.readings || []).filter((x:IReadings)=>x.directionId === el.id && x.position === elements.position).map((x:IReadings)=>x.count);
                    let totalCount = Array.from({length: el.totalCounts}, (_, index) => index + 1);
                    let uniqueDat = _.uniq(findCount) || [];
                    let diffData =_.difference(totalCount, uniqueDat);
                  return {
                    ...el,
                    skipped,
                    completedCounts: el.totalCounts,
                    skippedDetails:diffData
                  };
                });
                return elements;
              } else {
                let totalSkipped: number = 0;
                let totalCompleted: number = 0;
                elements.directions = elements.directions
                  .reverse()
                  .map((el: any) => {
                    let skipped: number = el?.skipped ?? 0;
                    let completedCounts = el.completedCounts;
                    let skippedDetails = [];
                    if (
                      el.id ===
                      instrumentDetail.nextMeasuringPositionDireaction
                        .directionId
                    ) {

                      let findCount = (instrumentDetail.readings || []).filter((x:IReadings)=>x.directionId === el.id && x.position === elements.position).map((x:IReadings)=>x.count);
                    let totalCount = Array.from({length: el.totalCounts}, (_, index) => index + 1);
                    let uniqueDat = _.uniq(findCount) || [];
                    let diffData =_.difference(totalCount, uniqueDat);

                    skippedDetails=diffData;
                      skipped =
                        (el?.skipped ?? 0) +
                        (el.totalCounts - el.completedCounts);
                      completedCounts = el.totalCounts;
                      totalSkipped += skipped;
                      totalCompleted += el.totalCounts;
                    } else if (el.name === "All") {
                      skipped = totalSkipped;
                      completedCounts = totalCompleted;
                      skippedDetails = el.skippedDetails;
                    } else {
                      totalSkipped += el?.skipped ?? 0;
                      totalCompleted += el.completedCounts;
                      skippedDetails = el.skippedDetails;
                    }

                    return {
                      ...el,
                      skipped,
                      completedCounts,
                      skippedDetails
                    };
                  });
                elements.directions.reverse();
                return elements;
              }
            } else {
              return elements;
            }
          }
        );

        instrumentDetail.nextMeasuringPositionDireaction =
          instrumentDetail.getNextMeasuringDetails(
            instrumentDetail.countData,
            instrumentDetail.allDirections,
            this.state.selectedSampleDetail?.testPlan,
            instrumentDetail.readings,
          );

        let NextPosition: any = null;
        if (instrumentDetail.nextMeasuringPositionDireaction.directionId) {
          NextPosition = instrumentDetail.countData.find(
            (elements: any) =>
              elements.position ===
              instrumentDetail.nextMeasuringPositionDireaction.position
          );
        }
        let completedCounts: number = 0;
        instrumentDetail.countData.forEach((elem: any) => {
          completedCounts += elem.directions[0]?.completedCounts ?? 0;
        });

        instrumentDetail.setCount({
          completedCounts,
          totalCounts: instrumentDetail.count.totalCounts,
        });

        instrumentDetails[instrumentDetailIndex] = instrumentDetail;
        this.setState({
          measurementDetails: {
            ...this.state.measurementDetails,
            instrumentDetails,
          },
          selectedPosition: NextPosition,
          isDashboardDetails: (!NextPosition && this.state.isDashboardDetails=== 3) ? 2 : this.state.isDashboardDetails,
        });
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="layout-margin">
            <div
              ref={this.props.childRef}
              className={`row content-section ${
                this.props.sidebarCollapsed ? "expanded" : ""
              }`}
            >
              <div className="container-fluid py-2 px-0">
                <div className="row content-header px-0">
                  <div className="col-xl-6 col-lg-6 col-md-4">
                    <h4> {this.props.instrumentData?.name ?? ""}</h4>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-8">
                    <ul className="navbar-nav mr-auto d-block float-right">
                      <li className="nav-item" onClick={this.onRefresh}>
                        <Button
                          icon={true && "abb/refresh"}
                          sizeClass="medium"
                          type="primary-blue"
                          shape={"pill"}
                          text={t(CONSTANTS.BUTTON_REFRESH)}
                        />
                      </li>
                      <li className="nav-item">
                        <WithTooltip>
                          <Button
                            sizeClass="medium"
                            type="discreet-black"
                            shape={"pill"}
                            icon={"abb/menu-narrow"}
                            onClick={this.onEditCall}
                          />
                          <Tooltip className="nav-tooltip">
                            <p>{t(CONSTANTS.MORE)}</p>
                          </Tooltip>
                        </WithTooltip>
                        {this.state.isEditShow && (
                          <div
                            className="ul-class "
                            style={{
                              marginLeft: -75,
                            }}
                          >
                            <Menu onLostFocus={this.onEditCall}>
                              <MenuItem
                              disabled={!authUtility.hasPermission([`${CONSTANTS.AUTHKEY_INSTRUMENT_MODE}:Edit`])}
                                text={t(CONSTANTS.EDIT)}
                                onSelect={this.onEditClick}
                              />
                              <MenuItem
                              disabled={!authUtility.hasPermission([`${CONSTANTS.AUTHKEY_INSTRUMENT_MODE}:Delete`])}
                                text={t(CONSTANTS.DELETE)}
                                onSelect={this.openDeleteDialog}
                              />
                            </Menu>
                          </div>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row mx-1 py-2 px-0">
                  <Summary>
                    <ul className="navbar-nav summaryList">
                      <li>
                        <span className="tagName">
                          {t(CONSTANTS.LABLE_INSTRUMENT_CODE)}:{" "}
                        </span>
                        <span>
                          {this.props.instrumentData &&
                          this.props.instrumentData.codeId
                            ? this.props.instrumentData.codeId
                            : ""}
                        </span>
                      </li>
                      <li>
                        <span className="tagName">
                          {t(CONSTANTS.LABLE_INSTRUMENT_TYPE)}:{" "}
                        </span>
                        <span>
                          {this.props.instrumentData &&
                          this.props.instrumentData.name
                            ? this.props.instrumentData.type.name
                            : ""}
                        </span>
                      </li>
                      <li>
                        <span className="tagName">
                          {t(CONSTANTS.LABLE_INSTRUMENT_STATE)}:{" "}
                        </span>
                        <span>
                          {this.props.instrumentData &&
                          this.props.instrumentData.state
                            ? this.props.instrumentData.state
                            : ""}
                        </span>
                      </li>
                      {this.props.deviceData.connectionType !== "Network Sharing" && <React.Fragment><li>
                        <span className="tagName">
                          {t(CONSTANTS.LABLE_INSTRUMENT_PORT)}:{" "}
                        </span>
                        <span>
                          {this.props.deviceData && this.props.deviceData.port
                            ? this.props.deviceData.port
                            : ""}
                        </span>
                      </li>
                      <li>
                        <span className="tagName">
                          {t(CONSTANTS.LABLE_INSTRUMENT_IP)}:{" "}
                        </span>
                        <span>
                          {this.props.deviceData &&
                          this.props.deviceData.ipAddress
                            ? this.props.deviceData.ipAddress
                            : ""}
                        </span>
                      </li></React.Fragment>}
                    </ul>
                  </Summary>
                </div>
                <div className="row content-body">
                  {" "}
                  <div className="mt-2 summary">
                    <div className="summary-text">
                      <div className="d-inline-block">
                        {t(CONSTANTS.TITLE_TESTOVERVIEW)}
                      </div>
                    </div>
                  </div>
                  <div className="header-underline" />
                  <div className="col-12">
                    {this.state.measurementDetails.sampleDetails != null &&
                    this.state.measurementDetails.sampleDetails.length > 0 &&
                    this.state.isDashboardDetails === 1 ? (
                      <Dashboard
                        onSelectTab={this.onSelectTab}
                        sampleDetails={
                          this.state.measurementDetails.sampleDetails
                        }
                        startInstrumentMeasurement={
                          this.startInstrumentMeasurement
                        }
                        stopInstrumentMeasurement={
                          this.stopInstrumentMeasurement
                        }
                        resumeInstrumentMeasurement={
                          this.resumeInstrumentMeasurement
                        }
                        remeasureInstrumentMeasurement={
                          this.remeasureInstrumentMeasurement
                        }
                        selectedPositionFromMeasuring={
                          this.state.selectedPositionFromMeasuring
                        }
                        reMeasureDirectionPositionCount={
                          this.reMeasureDirectionPositionCount
                        }
                      ></Dashboard>
                    ) : this.state.measurementDetails.sampleDetails != null &&
                      this.state.measurementDetails.sampleDetails.length > 0 &&
                      this.state.isDashboardDetails === 2 ? (
                      <InstrumentProperty
                        startInstrumentMeasurement={
                          this.startInstrumentMeasurement
                        }
                        stopInstrumentMeasurement={
                          this.stopInstrumentMeasurement
                        }
                        resumeInstrumentMeasurement={
                          this.resumeInstrumentMeasurement
                        }
                        remeasureInstrumentMeasurement={
                          this.remeasureInstrumentMeasurement
                        }
                        selectedInstrumentDetail={
                          this.state.selectedSampleDetail || null
                        }
                        thresholdSettings={this.state.thresholdSettings}
                        showDashboardDetails={this.showDashboardDetails}
                        showInstrumentPropertyDetails={this.showInstrumentPropertyDetailsComponent}
                      />
                    ) :  this.state.measurementDetails.sampleDetails != null &&
                    this.state.measurementDetails.sampleDetails.length > 0 &&
                    this.state.isDashboardDetails === 3 ? (
                    <InstrumentPropertyDetails
                      startInstrumentMeasurement={
                        this.startInstrumentMeasurement
                      }
                      stopInstrumentMeasurement={
                        this.stopInstrumentMeasurement
                      }
                      resumeInstrumentMeasurement={
                        this.resumeInstrumentMeasurement
                      }
                      remeasureInstrumentMeasurement={
                        this.remeasureInstrumentMeasurement
                      }
                      selectedInstrumentDetail={
                        this.state.selectedSampleDetail || null
                      }
                      thresholdSettings={this.state.thresholdSettings}
                      showDashboardDetails={this.showDashboardDetails}
                      reMeasureDirectionPositionCount={
                        this.reMeasureDirectionPositionCount
                      }
                      reMeasureDirectionPositionCountAll={
                        this.reMeasureDirectionPositionCountAll
                      }
                      reMeasureDirectionPositionCountSingleAll={
                        this.reMeasureDirectionPositionCountSingleAll
                      }
                      selectedPosition={this.state.selectedPosition}
                      skipCountInPosition={this.skipCountInPosition}
                      endPosition={this.endPositionFunc}
                      onRefresh={this.getInitialDataTest}
                    />
                  ):(
                      t(CONSTANTS.NO_SAMPLES_FOUND)
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Dialog
              isOpen={this.state.showInstrumentStopDialog}
              onClose={() => this.setState({ showInstrumentStopDialog: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.SAMPLE_INSTRUMENT_STOPPED_MSG)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.stopAfterConfirm,
                },
              ]}
            />
            <Dialog
              isOpen={this.state.showInstrumentRemeasureDialog}
              onClose={() =>
                this.setState({ showInstrumentRemeasureDialog: false })
              }
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.SAMPLE_INSTRUMENT_REMEASURE_MSG)}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.remeasureAfterConfirmation,
                },
              ]}
            />

            <Dialog
              isOpen={this.state.deleteModalVisible}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ deleteModalVisible: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.DELETE_TITLE, {
                name: this.state.deleteTitle,
              })}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.onDeleteClick,
                },
              ]}
            >
              <div>
                {t(CONSTANTS.DELETE_MESSAGE, {
                  name: "",
                  module: t(this.state.moduleName),
                })}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.DELETE_POPUP_MESSAGE)}
              </div>
            </Dialog>
          </div>
        )}
      </Translation>
    );
  }
}
